<template>
  <GoogleDocsHTMLExportRenderer :copy="copy" />
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import GoogleDocsHTMLExportRenderer from '@/modules/InformationPages/Legal/components/GoogleDocsHTMLExportRenderer.vue'
import copy from './Payroll.copy.ts'
import useGlobalSettings from '@/hooks/useGlobalSettings';


export default defineComponent({
  name: 'Payroll',
  components: { GoogleDocsHTMLExportRenderer },
  setup() {
    const { setHeader } = useGlobalSettings();

    setHeader({
      header: 'Payroll Terms of Service',
      subheader: null,
      heroImage: null,
      metaTitle: `Payroll Terms of Service`,
      registration: false,
      noHero: false,
    });

    return {
      copy
    }
  }
});
</script>

